<template>
  <div class="home">
    <HelloWorld msg="Welcome to Your Vue.js App" />
    <button type="button" @click="logout">Cerrar sesión</button>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
import firebase from "firebase";

export default {
  name: "home",
  methods: {
    setLayout(layout) {
      this.$store.commit("SET_LAYOUT", layout);
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("/");
          this.$router.go();
        });
    }
  },
  components: {
    HelloWorld
  },
  mounted() {
    this.setLayout("home-layout");
  }
};
</script>
